import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CommonHttpService } from '../../services/common-http/common-http.service';
import { ElectronService } from '../../services/electron/electron.service';

@Component({
    selector: 'app-vplaybook-audio-player',
    templateUrl: './vplaybook-audio-player.component.html',
    styleUrls: ['./vplaybook-audio-player.component.scss'],
    standalone: false
})
export class VplaybookAudioPlayerComponent {

  primaryUrl: string = '';
  audioSrc: string;
  isPlaying: boolean = false;
  offlineAppPath: any;
  isSecondTime = false;
  onErrorCalled = 0;
  onErrorFuncAllowed = true;
  @ViewChild('audioPlayer') audioPlayer: ElementRef<any>;
  @Input() audioAssetId: string;
  @Input() isLoadAudio: boolean = true;
  @Input() audioClass: string = '';
  @Input() preload = 'none';
  @Input() onErrorRetry: number = 3;
  @Input() public set setAudioSrc(audioSrc: string) {
    this.audioSrc = audioSrc;
    this.fetchAudioUrl();
  }
  @Input() public set setIsPlaying(isPlaying: boolean) {
    this.isPlaying = isPlaying;
    this.playAudio();
  }

  constructor(
    private commonHttpService: CommonHttpService,
    private electronService: ElectronService
  ) {
    this.offlineAppPath = this.electronService.appPath;
  }


  playAudio() {
    if (this.audioSrc) {
      if (this.isPlaying) {
        this.audioPlayer.nativeElement.play();
      } else if (!this.audioPlayer.nativeElement.pause()) {
        this.audioPlayer.nativeElement.pause();
      } else if (this.audioSrc.includes('data') || this.audioSrc.includes(this.offlineAppPath)) {
        //  data url and offline
      }
    }
  }

  fetchAudioUrl(isCurrentTime = false) {
    let currentTime;
    if (isCurrentTime) {
      currentTime = this.audioPlayer.nativeElement.currentTime;
      this.onErrorCalled++;
      if(this.onErrorCalled === this.onErrorRetry) {
        this.onErrorFuncAllowed = false;
      }
    }
    if(this.audioSrc !== '') {
      if (this.audioSrc.includes('data') || this.audioSrc.includes(this.offlineAppPath)) {
        this.primaryUrl = this.audioSrc;
      } else {
        this.commonHttpService.get<any>({
          uri: this.audioSrc,
          message: {
            showMessage: false
          }
        }).subscribe((audioDataUrl) => {
          if (isCurrentTime && this.isSecondTime) {
            this.audioPlayer.nativeElement.src = audioDataUrl;
            this.audioPlayer.nativeElement.play();
            this.audioPlayer.nativeElement.currentTime = currentTime;
          } else {
            this.isSecondTime = true;
            this.primaryUrl = audioDataUrl;
          }
        });
      }
    }
  }
}